import { useCallback, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { ReportGarantiaPorVencimiento } from "../../../../../api/Api";
import ClusteredChart from "../../../../../Components/AmCharts/ClusteredChart";
import DonutChart from "../../../../../Components/AmCharts/DonutChart";
import './GarantiaChart.css'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

export default function GarantiaPorVencimiento() {

  const CF_NO_VENCIDAS = useRef("cf_no_vencidas");
  const CF_VENCIDAS = useRef("cf_vencidas");

  const { data: garantiaPorVencimientoRes } = useQuery("reporteGarantiaPorVencimiento", ReportGarantiaPorVencimiento);

  const [garantiaPorVencimientoDonut, setGarantiaPorVencimientoDonut] = useState([]);
  const [garantiaPorVencimientoTotal, setGarantiaPorVencimientoTotal] = useState(null);

  const [garantiasVencidasList, setGarantiasVencidasList] = useState([]);
  const [garantiasNoVencidasList, setGarantiasNoVencidasList] = useState([]);
  const [garantiasNoVencidasAnioSelected, setGarantiasNoVencidasAnioSelect] = useState({ value: -1, label: "Todos" });
  const [garantiasVencidasAnioSelected, setGarantiasVencidasAnioSelect] = useState({ value: -1, label: "Todos" });

  //Para refactorizar
  const getGarantiasPorCategoria = useCallback((categoria) => {
    const index = garantiaPorVencimientoRes.data.detail.findIndex(item => item.categoria === categoria);
    return garantiaPorVencimientoRes.data.detail[index] || [];
  }, [garantiaPorVencimientoRes]);

  const getGarantiasVencidasClustered = useCallback((categoria, anio) => {
    const data = getGarantiasPorCategoria(categoria);
    return data.detalle?.find((item) => item.anio === anio).items;
  }, [getGarantiasPorCategoria])
  //////
  const transformOption = useCallback((categoria, valueKey, labelKey) => {
    const data = getGarantiasPorCategoria(categoria);
    return data.anios?.map(item => ({
      value: item[valueKey],
      label: item[labelKey] || "Todos"
    }));
  }, [getGarantiasPorCategoria]);

  const handleChangeGarantiasAnio = useCallback((e, categoria) => {

    if (categoria === CF_VENCIDAS.current) {
      setGarantiasVencidasList(getGarantiasVencidasClustered(categoria, e.value));
      setGarantiasVencidasAnioSelect(e);
    } else {
      setGarantiasNoVencidasList(getGarantiasVencidasClustered(categoria, e.value));
      setGarantiasNoVencidasAnioSelect(e);
    }

  }, [getGarantiasVencidasClustered])

  useEffect(() => {
    if (garantiaPorVencimientoRes?.success) {

      const data = garantiaPorVencimientoRes.data.summary.map((item) => {
        if (item.categoria === CF_NO_VENCIDAS.current) {
          item.categoria = "No Vencidas";
          return item
        } else {
          item.categoria = "Vencidas";
          return item;
        }
      });

      const total = data.reduce((total, item) => total + item.cantidad, 0);
      setGarantiaPorVencimientoDonut(data);
      setGarantiaPorVencimientoTotal(total);

      setGarantiasNoVencidasList(getGarantiasVencidasClustered(CF_NO_VENCIDAS.current, -1));
      setGarantiasVencidasList(getGarantiasVencidasClustered(CF_VENCIDAS.current, -1));

    }
  }, [garantiaPorVencimientoRes, getGarantiasVencidasClustered])

  return (
    <>
      {garantiaPorVencimientoDonut.length > 1 &&
        garantiaPorVencimientoTotal && (
          <Accordion defaultActiveKey={['0']} alwaysOpen>

            <Accordion.Item eventKey="0">
              <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Garantía Total</span></Accordion.Header>
              <Accordion.Body>
                <div className="row">
                  <div className="col-12">
                    <DonutChart
                      id="donutXvencer"
                      data={garantiaPorVencimientoDonut}
                      isDonut={true}
                      category={"categoria"}
                      value={"cantidad"}
                      className={"donut-char"}
                      textCenter={garantiaPorVencimientoTotal}
                      tooltipText={"Cantidad: [bold]{value}[/] \n Importe: [bold]S/. {importe}[/]"}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Garantía Vencidas y No Vencidas</span></Accordion.Header>
              <Accordion.Body>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <Select classNamePrefix='filter'
                      components={makeAnimated()}
                      value={garantiasVencidasAnioSelected}
                      isMulti={false}
                      closeMenuOnSelect={true}
                      options={transformOption(CF_VENCIDAS.current, "value", "text")}
                      isSearchable={false}
                      onChange={(e) => handleChangeGarantiasAnio(e, CF_VENCIDAS.current)}
                      className={"select-garantia"}
                    />
                    <ClusteredChart
                      id={"clusteredVencidas"}
                      title={"Garantia Vencidas"}
                      data={garantiasVencidasList}
                      className={"clustered-chart mt-8"}
                      category={"codigo_mall"}
                      barPrimary={"cantidad"}
                      barSecondary={"importe"}
                      barPrimaryName={"Cantidad"}
                      barSecondaryName={"Importe"}
                      barPrimaryTooltip={"Cantidad: [bold]{valueY}[/]"}
                      barSecondaryTooltip={"Importe: [bold]S/ {valueY}[/]"}

                    // barPrimaryLabelBulletText={"{cantidad}"}
                    // barSecondaryLabelBulletText={"S/ {importe}"}
                    // maskBullets={false}
                    // paddingTop={70}
                    />
                  </div>
                  <div className="col-12 col-lg-6">
                    <Select classNamePrefix='filter'
                      components={makeAnimated()}
                      value={garantiasNoVencidasAnioSelected}
                      isMulti={false}
                      closeMenuOnSelect={true}
                      options={transformOption(CF_NO_VENCIDAS.current, "value", "text")}
                      isSearchable={false}
                      onChange={(e) => handleChangeGarantiasAnio(e, CF_NO_VENCIDAS.current)}
                      className={"select-garantia"}
                    />
                    <ClusteredChart
                      id={"clusteredNoVencidas"}
                      title={"Garantias No Vencidas"}
                      data={garantiasNoVencidasList}
                      className={"clustered-chart mt-8"}
                      category={"codigo_mall"}
                      barPrimary={"cantidad"}
                      barSecondary={"importe"}
                      barPrimaryName={"Cantidad"}
                      barSecondaryName={"Importe"}
                      barPrimaryTooltip={"Cantidad: [bold]{valueY}[/]"}
                      barSecondaryTooltip={"Importe: [bold]S/ {valueY}[/]"}
                    // barPrimaryLabelBulletText={"{cantidad}"}
                    // barSecondaryLabelBulletText={"S/ {importe}"}
                    // maskBullets={false}
                    // paddingTop={70}
                    />
                  </div>
                </div>

              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
    </>
  )
}